import { ActionMenuWrapper, DateUtil, DropdownMenuItem, Icon, TableColumn } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { IReportingProfileConfig } from '../../models/IReportingProfileConfig';
import { ExpandableTableRow } from '../common/ExpandableTableRow';
import { ConnectedGroupAccessOwnersForProfile } from './GroupAccessOwnersForProfile';

export const WarningText = styled.span`
	color: ${globalVars.tertiaryRed};
`;
WarningText.displayName = 'Warning Text';

export interface IReportingProfileConfigRowProps {
	hrisId: string;
	config: IReportingProfileConfig;
	defaultHierarchyName?: string;
	editAction: (config: IReportingProfileConfig) => void;
}

export class ReportingProfileConfigRow extends React.PureComponent<IReportingProfileConfigRowProps, { isExpanded: boolean }> {
	public state = {
		isExpanded: false,
	};

	public render() {
		const { hrisId, config, defaultHierarchyName } = this.props;

		const alreadyLive =
			config.scheduledMessageSequenceNumber !== null && (config.isOpenImmediately || moment(config.openOn!).isBefore(new Date()));

		return (
			<ExpandableTableRow
				key={config.reportingProfileConfigId}
				onIconClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
				expanded={this.state.isExpanded}
				expandedRowShowLeftBorder={true}
				expandedRowRender={() => (
					<TableColumn colSpan={7}>
						<ConnectedGroupAccessOwnersForProfile profileId={config.profileId} hrisId={hrisId} hierarchyIds={config.hierarchyIds} />
					</TableColumn>
				)}
			>
				<TableColumn>{config.name}</TableColumn>
				<TableColumn>{config.userCount}</TableColumn>
				<TableColumn>
					{config.isOpenImmediately ? (
						ContentConstants.REPORTING_PROFILES_TABLE_IMMEDIATELY_ON_SURVEY_CLOSE
					) : config.openOn != null ? (
						DateUtil.formatDateToLocal(new Date(config.openOn!))
					) : (
						<WarningText>
							-- <Icon name={'warning'} />
						</WarningText>
					)}
				</TableColumn>
				<TableColumn>0</TableColumn>
				<TableColumn>{defaultHierarchyName || '--'}</TableColumn>
				<TableColumn>
					<ActionMenuWrapper>
						<DropdownMenuItem onClick={() => this.props.editAction(config)} disabled={alreadyLive}>
							{ContentConstants.REPORTING_PROFILES_TABLE_ACTION_EDIT_GO_LIVE_INVITE}
						</DropdownMenuItem>
					</ActionMenuWrapper>
				</TableColumn>
			</ExpandableTableRow>
		);
	}
}
